export default {
    namespaced: true,
    state: {
        travel: "",
        departure: null,
        arrival: null,
        hotel: null,
        event: "",
        project: ""
    },
    mutations: {
        setTravel(state, data) { state.travel = data; },
        setDeparture(state, data) { state.departure = data; },
        setArrival(state, data) { state.arrival = data; },
        setHotel(state, data) { state.hotel = data; },
        setEvent(state, data) { state.event = data; },
        setProject(state, data) { state.project = data; },
        reset(state, data) {
            state.travel = "";
            state.departure = null;
            state.arrival = null;
            state.hotel = null;
            state.event = "";
            state.project = "";
        }
    },
    getters: {
        isset: function(state) {
            return state.travel != null && state.departure != null && state.arrival != null && state.hotel != null && state.event != null;
        },
        travel(state) {
            return state.travel;
        },
        departure(state) {
            return state.departure;
        },
        arrival(state) {
            return state.arrival;
        },
        hotel(state) {
            return state.hotel;
        },
        event(state) {
            return state.event;
        },
        project(state) {
            return state.project;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/travelformdata.js